export default "__VITE_ASSET__6RdUKvbt__"